module.exports = __webpack_public_path__ + "static/media/refrigeratorExplore.435b6094.png";